import React from "react";
import "../styles/skillstates.css";
import { useAudio } from "./AudioContext";

export default function SkillStates({ skillstate, setSkillState }) {
  const { playAudio } = useAudio();

  // Function to handle clicking on a circle
  const handleClick = (index) => {
    // Play audio
    playAudio();
    setSkillState(index);
  };

  return (
    <div className="skillstates">
      {[0, 1, 2].map((index) => (
        <div
          key={index}
          className={`state-circle ${index === skillstate ? "active" : ""}`}
          onClick={() => handleClick(index)}
        ></div>
      ))}
    </div>
  );
}
